import ActivityBadge from './ActivityBadge';
export default ActivityBadge;
